import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import CONFIG from "./config";

// Import your sample pages:
import SamplePublicPage from "./samplePublicPage";
import SampleDashboard from "./SampleDashboard";

const LoginPage = () => {
  const [redirectError, setRedirectError] = useState("");
      const [redirectSuccess, setRedirectSuccess] = useState("");
       // Handle redirect uccess or failure messages
      useEffect(() => {
              const queryParams = new URLSearchParams(window.location.search);
              const errorParam = queryParams.get("error");
              const successParam = queryParams.get("success");
            
              if (errorParam) {
                setRedirectError(errorParam);
              }
              if (successParam) {
                setRedirectSuccess(successParam);
              }
  
              // Remove the query parameters from the URL without reloading the page
              const newUrl = window.location.pathname;
              window.history.replaceState(null, "", newUrl);
            }, []);   
  const [formData, setFormData] = useState({ email: "", password: "", stayLoggedIn: false });
  const [registerData, setRegisterData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    referralCode: "",
  });
  const [forgotEmail, setForgotEmail] = useState("");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showRegisterFields, setShowRegisterFields] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [showMoreBusinessLeads, setShowMoreBusinessLeads] = useState(false);
  const [showTestimonials, setShowTestimonials] = useState(false);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [showMoreExperienceIt, setShowMoreExperienceIt] = useState(false);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1120);

  // Toggle the entire login/forgot-password/register block
  const [showLoginForms, setShowLoginForms] = useState(false);

  // Tabs for the right side
  const [activeTab, setActiveTab] = useState("public");

  const businessLeadsRef = useRef(null);
  const businessLeadsRef2 = useRef(null);
  const detailsRef = useRef(null);
  const detailsRef2 = useRef(null);
  const experienceItRef = useRef(null);
  const experienceItRef2 = useRef(null);
  const testimonialsRef = useRef(null);
  const testimonialsRef2 = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
        if (showMoreBusinessLeads && businessLeadsRef.current && businessLeadsRef2.current && !businessLeadsRef.current.contains(event.target) && !businessLeadsRef2.current.contains(event.target)) {
            setShowMoreBusinessLeads(false);
        }
        if (showMoreDetails && detailsRef.current && detailsRef2.current && !detailsRef.current.contains(event.target) && !detailsRef2.current.contains(event.target)) {
            setShowMoreDetails(false);
        }
        if (showMoreExperienceIt && experienceItRef2.current && !experienceItRef2.current.contains(event.target)) {
            setShowMoreExperienceIt(false);
        }
        if (showTestimonials && testimonialsRef.current && testimonialsRef2.current && !testimonialsRef.current.contains(event.target) && !testimonialsRef2.current.contains(event.target)) {
            setShowTestimonials(false);
        }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, [showMoreBusinessLeads, showMoreDetails, showMoreExperienceIt, showTestimonials]);

  useEffect(() => {
    const checkAuth = async () => {
        try {
            const response = await axios.get(`${CONFIG.BACKEND_URL}/api/check-auth`, {
                withCredentials: true, // Ensures cookies are sent with the request
            });

            if (response.data.authenticated) {
                navigate("/dashboard"); // Redirect if already authenticated
            }
        } catch (err) {
            console.log("User is not authenticated.");
        }
    };

    checkAuth();
}, []);
  
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + CONFIG.siteKey;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Handle verification success or failure messages
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("verified") === "true") {
      setMessage("✅ Registration successful! You can now log in.");
    } else if (params.get("error") === "invalid_token") {
      setError("❌ Verification failed. Invalid or expired token.");
    }
    // Remove the query parameters from the URL without reloading the page
    const newUrl = window.location.pathname;
    window.history.replaceState(null, "", newUrl);
  }, [location.search]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
        const token = await window.grecaptcha.enterprise.execute(CONFIG.siteKey, { action: "submit" });

        await axios.post(`${CONFIG.BACKEND_URL}/api/login`, {
            ...formData,
            recaptchaToken: token,
            action: "submit",
            stayLoggedIn: formData.stayLoggedIn,
        }, {
            withCredentials: true, // Ensures cookies are sent with request
        });

        navigate("/dashboard"); // Redirect after successful login
    } catch (err) {
        setError(err.response?.data?.error || "Login failed.");
    }
};

  const handleRegister = async (e) => {
    setMessage("");
    setError("");
    e.preventDefault();
    if (registerData.email === "") {
      setError("Please enter your email.");
      return;
    }
    if (registerData.password === "") {
      setError("Please enter your password.");
      return;
    }
    if (registerData.confirmPassword === "") {
      setError("Please confirm your password.");
      return;
    }
    if (registerData.password !== registerData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    try {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const requestData = {
        email: registerData.email,
        password: registerData.password,
        timezone: userTimezone,
        referralCode: registerData.referralCode?.toLowerCase(),
      };

      const token = await window.grecaptcha.enterprise.execute(CONFIG.siteKey, { action: 'submit' });
            
      const response = await axios.post(`${CONFIG.BACKEND_URL}/api/pre-register`, {
                  ...requestData,
                  recaptchaToken: token,
                  action: "submit",
                     });
      setMessage(response.data.message || "📩 Verification email sent. \nPlease check your inbox to complete registration.\n Check the spam/junk mail if you don't see it");      
      setShowRegisterFields(false);
    } catch (err) {
      if (err.response && err.response.status === 400) {
        const errorMessage = err.response.data.error || "Invalid request. Please check your input.";
        setError(errorMessage);
      } else {
        setError("Registration failed. Please try again.");
      }
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      setError("Please enter your email.");
      return;
    }
    try {
      const response = await axios.post(`${CONFIG.BACKEND_URL}/api/forgot-password`, {
        email: forgotEmail,
      });
      setMessage(response.data.message);
      setError("");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to reset password.");
    }
  };

  useEffect(() => {
    const handleResize = () => {
        setIsWideScreen(window.innerWidth > 1120);
    };

    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
        window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {/* Inline CSS via <style> for media queries */}
      <style>{`
        .page-wrapper {
          width: auto;
          display: flex;
          flex-direction: row;
          height: auto;
          font-family: Arial, sans-serif;
        }
        
        .left-panel {
          width: 30%;
          height: 100%;
          padding: 20px;
          padding-top: 0px;
          padding-left: 10%;
          padding-right: 10%;
          overflow-y: auto;
          margin-bottom: 20px;
        }
        
        .right-panel {
          width: 70%;
          height: 100%;
          background-color: rgb(84, 84, 84);
          padding: 0px;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
        }
        .footer {
          margin-top: 50px;
          padding: 0px;
          background-color:rgb(226, 218, 195);
          text-align: center;
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: 12px;
          height: 40px;
        }

        /* On smaller screens, stack top-to-bottom */
        @media (max-width: 1120px) {
          .page-wrapper {
            flex-direction: column;
          }
          .left-panel {
            width: auto;
          }
          .right-panel {
            width: 100% !important;
          }
        }
        .tabs-header {
          display: flex;
          margin-bottom: 0px;
        }
        .tab-button {
          flex: 1;
          margin-right: 0px;
          padding: 10px;
          cursor: pointer;
          color: #fff;
          border: none;
          border-radius: 0px;
          background-color: #ccc;
          font-weight: bold;
        }
        .tab-button.active {
          background-color: #2c3e50;
        }
        .tab-content {
          flex: 1;
          background-color: #fff;
          padding: 0px;
          border-radius: 0px;
          overflow-y: auto;
        }
        .top-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0 0 0;
          line-height: 1.6;
        }
        .logo {
          font-family: Verdana, sans-serif;
          font-weight: bold;
          font-size: 24px;
          color: #2c3e50;
          margin: 0;
        }
        .login-toggle-btn {
          padding: 8px 15px;
          border: none;
          border-radius: 5px;
          background-color: #2c3e50;
          color: #fff;
          cursor: pointer;
          font-size: 14px;
          font-weight: bold;
        }
        .top-main-text {
          color: rgb(0, 109, 160);
          font-weight: bold;
          margin-top: 60px;
          margin-bottom: 40px;
        }
        .main-text {
          color: rgb(112, 23, 116);
          font-weight: bold;
          margin-top: 50px;
          margin-bottom: 40px;
        }
        .mid-main-text {
          color: rgb(0, 92, 3);
          font-weight: bold;
          margin-top: 50px;
          margin-bottom: 40px;
        }
        .sub-main-text {
          color: rgb(210, 94, 37);
          font-weight: bold;
          margin-top: 50px;
        }
        .subtitle {
          font-size: 16px;
          color: #555;
          margin-bottom: 20px;
        }
        .input-box {
          width: 80%;
          padding: 5px;
          border-radius: 5px;
          border: 1px solid #ccc;
          font-size: 16px;
          margin: 10px 0;
          display: block;
        }
        .button-row {
          width: 100%;
          text-align: left;
        }
        .common-button {
          padding: 10px 20px;
          background-color: #007bff;
          color: #fff;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          margin-top: 10px;
        }
        .privacy-terms-box {
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 8px;
          background-color: #f9f9f9;
          max-height: 400px;
          overflow-y: auto;
        }
        .details-section {
          position: absolute;
          z-index: 1000;
          left: 20%;
          margin-top: -30px;
          max-width: 260px;
          padding: 5px 20px 10px 20px;
          border-radius: 8px;
          background-color: #e0e0e0;
          margin-bottom: 20px;
          font-size: 12px;
          text-align: left;
          font-weight: bold;
      }
      `}</style>

      <div className="page-wrapper">
        {/* Left side */}
        <div className="left-panel">
          <div className="top-section">
            <p className="logo">
              <a href={`${CONFIG.FRONTEND_URL}`} style={{ textDecoration: "none", color: "inherit" }}>
                Rili Day
              </a>
            </p>

            {/* Toggle button: show/hide forms */}
            <button
              className="login-toggle-btn"
              onClick={() => setShowLoginForms(!showLoginForms)}
            >
              {showLoginForms ? "Hide" : "Login or Register"}
            </button>
          </div>

          {error && <p style={{ color: "red" }}>{error}</p>}
          {message && <p style={{ color: "green" }}>{message}</p>}
          {redirectError && <p style={{ color: "red" }}>{redirectError}</p>}
          {redirectSuccess && <p style={{ color: "green" }}>{redirectSuccess}</p>}

          {/* Conditionally show the entire login/forgot-password/register block */}
          {showLoginForms && (
            <>
              <h1 className="subtitle">Login</h1>
              

              <form onSubmit={handleLogin}>
                <input
                  className="input-box"
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
                <input
                  className="input-box"
                  type="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                />
                <div>
                  <input
                    type="checkbox"
                    id="stayLoggedIn"
                    checked={formData.stayLoggedIn}
                    onChange={(e) => setFormData({ ...formData, stayLoggedIn: e.target.checked })}
                  />
                  <label htmlFor="stayLoggedIn">Stay logged in on this browser</label>
                </div>
                <div className="button-row">
                  <button type="submit" className="common-button" style={{ backgroundColor: "#28a745" }}>
                    Login
                  </button>
                </div>
              </form>

              <button onClick={() => setShowForgotPassword(!showForgotPassword)} className="common-button">
                Forgot Password?
              </button>

              {showForgotPassword && (
                <div>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    className="input-box"
                  />
                  <div className="button-row">
                    <button onClick={handleForgotPassword} className="common-button">
                      Reset Password
                    </button>
                  </div>
                </div>
              )}

              <div className="button-row">
                <button onClick={() => setShowRegisterFields(!showRegisterFields)} className="common-button">
                  Register as a New User
                </button>
              </div>

              {showRegisterFields && (
                <form onSubmit={handleRegister} style={{ marginTop: "10px" }}>
                  <input
                    className="input-box"
                    type="email"
                    placeholder="Email"
                    value={registerData.email}
                    onChange={(e) => setRegisterData({ ...registerData, email: e.target.value })}
                  />
                  <input
                    className="input-box"
                    type="password"
                    placeholder="Password"
                    value={registerData.password}
                    onChange={(e) => setRegisterData({ ...registerData, password: e.target.value })}
                  />
                  <input
                    className="input-box"
                    type="password"
                    placeholder="Confirm Password"
                    value={registerData.confirmPassword}
                    onChange={(e) => setRegisterData({ ...registerData, confirmPassword: e.target.value })}
                  />
                  <input
                    className="input-box"
                    type="text"
                    placeholder="Referral Code (optional)"
                    value={registerData.referralCode}
                    onChange={(e) => setRegisterData({ ...registerData, referralCode: e.target.value })}
                  />
                  <div style={{ margin: "10px 0" }}>
                    <input type="checkbox" required />
                    <span> Check to agree with the 
                                {" "}
                                <a href={`${CONFIG.FRONTEND_URL}/privacy`} target="_blank" rel="noopener noreferrer">
                                    privacy terms
                                </a>
                                {" "}|{" "}
                                <a href={`${CONFIG.FRONTEND_URL}/terms`} target="_blank" rel="noopener noreferrer">
                                    terms of service
                                </a>.
                            </span>
                  </div>
                  <button type="submit" className="common-button">
                    Register
                  </button>
                </form>
              )}
            </>
          )}
          <div className="top-main-text">
            <p>Register before Sept 1, 2025 EST 
              <br />
              to get lifetime ad-free privilege!</p>
            <h1>
              <br />
              <br />
              
            </h1>
          </div>
          
          <div className="main-text">
            <h1>
              3 min
              <br /> to create your
              <br /> 
              
            
            <a
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => setShowMoreDetails(!showMoreDetails)}
              ref={detailsRef2}
            >
              business page
            </a>
            {" "}with
            <br />
            a booking system
              <br />
              for FREE
            </h1>
            {showMoreDetails && 
            <div ref={detailsRef}>
            <p>
              Rili Day is NOT a platform, but a simple tool.
              <br />
              <br />
              Claim www.rili.day/yourbusinessname.
              <br />
              <br />
              Put it on your Google Maps page, <br />existing website or social media.
              <br />
              <br />
              Customers can book online directly without registration or login.
              <br />
              <br />
              Free features can fulfill almost all your needs:
              <br />
              </p>
              <p style={{fontSize: '14px'}}>
              - permanent business page and URL;
              <br />
              - up to 20 appointments per month for free;
              <br />
              - confirmation emails to customers and business;
              <br />
              - auto-confirm or manual approval;
              <br />
              - event reminder emails to customers and business;
              <br />
              - customer email validation to prevent spam;
              <br />
              - and more!
              <br />
              
            </p>
            </div>}
          </div>

          

          <div className="mid-main-text">
            <h1>
              Business with a
              <br /> bookable calendar
              <br /> sees  <a
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => setShowMoreBusinessLeads(!showMoreBusinessLeads)}
                  ref={businessLeadsRef}
              >
                  347% MORE <br /> BUSINESS leads
              </a>
            </h1>
            {showMoreBusinessLeads && <div ref={businessLeadsRef2}>
              Customers don't like to call or submit a form.
              <br />
              <br />
              They like to know your availability and book online directly.
              <br />
              <br />
              You can set auto-confirm or manual approval.
              <br />
              <br />
              The point is, you get the business leads.
              
              
            </div>}
          </div>

          <div className="mid-main-text" style={{color: '#3661ab', fontSize: '14px'}}>
            <h1>
              <a
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => setShowTestimonials(!showTestimonials)}
                  ref={testimonialsRef2}
              >
                How others use 
              </a>
              {" "}Rili Day
            </h1>
            {showTestimonials && <div ref={testimonialsRef}>
              Tango IT Services:
              {" "}<a href="https://www.rili.day/tangoit" target="_blank" rel="noopener noreferrer">
                rili.day/tangoit
              </a>
              <br />
              LedGuru Lighting Inc:
              {" "}<a href="https://www.rili.day/ledgurulighting" target="_blank" rel="noopener noreferrer">
                rili.day/ledgurulighting
              </a>
              
            </div>}
          </div>

          <div className="sub-main-text">
            <h1>
              <a
                style={{ cursor: "pointer", textDecoration: "underline" }}
                ref={experienceItRef2}
                onClick={() => {setTimeout(() => {
                  if (experienceItRef.current && !isWideScreen) {
                      experienceItRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                  setShowMoreExperienceIt(!showMoreExperienceIt);
              }, 100);}}
              >
                Experience it
              </a> first
              <br />
              before you register &#8594;
            </h1>
            {isWideScreen && showMoreExperienceIt && (
                <p>
                    Check the sample pages on the right to get a taste of what Rili Day can do for your business.
                </p>
            )}
          </div>

          
        </div>

        

        {/* Right side: Tabbed sample pages */}
        <div className="right-panel" ref={experienceItRef}>
          <div className="tabs-header">
            <button
              className={`tab-button ${activeTab === "public" ? "active" : ""}`}
              onClick={() => setActiveTab("public")}
            >
              Sample Public Page
            </button>

            <button
              className={`tab-button ${activeTab === "dashboard" ? "active" : ""}`}
              onClick={() => setActiveTab("dashboard")}
            >
              Sample Dashboard
            </button>
          </div>

          <div className="tab-content">
            {activeTab === "dashboard" && <SampleDashboard />}
            {activeTab === "public" && <SamplePublicPage />}
          </div>
        </div>
      </div>
      <div className="footer">
          <p>
            <a href={`${CONFIG.FRONTEND_URL}/privacy`}>Privacy Policy</a>
            {" "}|{" "}
            <a href={`${CONFIG.FRONTEND_URL}/terms`}>Terms of Service</a>
          </p>
      </div>
    </>
  );
};

export default LoginPage;
